import { ICONS } from '../icons.js';

// ─── Tamaños predefinidos ──────────────────────────────────────────────────────
const SIZES = {
  xs: { container: 'w-10 h-10', icon: 'w-5 h-5', padding: 'py-3 px-5', title: 'text-base font-medium' },
  sm: { container: 'w-10 h-10', icon: 'w-5 h-5', padding: 'p-6', title: 'text-xl font-semibold' },
  md: { container: 'w-14 h-14', icon: 'w-8 h-8', padding: 'p-6', title: 'text-xl font-semibold' },
  lg: { container: 'w-16 h-16', icon: 'w-10 h-10', padding: 'p-6', title: 'text-xl font-semibold' },
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-fam-card]").forEach((wrap) => {
    const root = wrap.querySelector(".js-fam-card");
    if (!root) return;

    // 1. Elementos del DOM interno de fam-card.html
    const iconWrapper = root.querySelector(".js-fam-card-icon-wrapper");
    const iconSvg = root.querySelector(".js-fam-card-icon");
    const titleEl = root.querySelector(".js-fam-card-title");
    const textEl = root.querySelector(".js-fam-card-text");

    // 2. Leer propiedades pasadas por data-*
    const iconName = wrap.dataset.cardIcon; // Ya no tiene default porque puede ser un número
    const number = wrap.dataset.cardNumber;
    const title = wrap.dataset.cardTitle || '';
    const text = wrap.dataset.cardText || '';
    const align = wrap.dataset.cardAlign || 'center';
    const size = wrap.dataset.cardSize || 'md';
    const color = wrap.dataset.cardColor || 'primary'; // Por defecto, toma theme color primary

    // 3. Hidratar contenido
    if (number) {
      // Es una tarjeta numerada
      iconSvg.outerHTML = `<span class="js-fam-card-icon pointer-events-none font-bold text-white text-base md:text-xl">${number}</span>`;
      iconWrapper.classList.remove('bg-white/40', 'border', 'border-tinta/30');
      iconWrapper.classList.add(`bg-${color}`);
    } else {
      // Es una tarjeta con icono de la librería
      const iconKey = iconName || 'star';
      iconSvg.innerHTML = ICONS[iconKey] || ICONS['star'];
    }

    titleEl.textContent = title;

    if (text) {
      textEl.innerHTML = text; // innerHTML por si el texto trae html como <br>
    } else if (textEl) {
      textEl.remove(); // Si no hay texto, quitamos el nodo p
    }

    // 4. Adaptar colores y tamaños
    root.classList.remove('border-primary', 'p-6'); // Quitamos defaults del template
    root.classList.add(`border-${color}`);

    const { container, icon, padding, title: titleStyle } = SIZES[size] || SIZES['md'];
    
    iconWrapper.classList.add(...container.split(' '));
    if (!number) {
      iconSvg.classList.add(...icon.split(' '));
    }
    if (padding) {
      root.classList.add(...padding.split(' '));
    }
    if (titleStyle) {
      // Quitamos la configuración por defecto del HTML y añadimos la específica de tamaño
      titleEl.classList.remove('text-xl', 'font-semibold');
      titleEl.classList.add(...titleStyle.split(' '));
    }

    // 5. Motor de Layout (Basado en CSS Grid Plana)
    root.classList.add('grid');

    if (align === 'center') {
      // Todo centrado, uno debajo de otro
      root.classList.add('grid-cols-1', 'justify-items-center', 'text-center');
      titleEl.classList.add('mt-3', 'mb-2');

    } else if (align === 'left') {
      // Icono a la izquierda, título al lado; texto debajo ocupando 2 columnas
      root.classList.add('grid-cols-[auto_1fr]', 'gap-x-3', 'items-center', 'text-left');
      if (text) textEl.classList.add('col-span-2', 'mt-3');

    } else if (align === 'right') {
      // Icono a la derecha, título a la izq; texto debajo ocupando 2 columnas
      root.classList.add('grid-cols-[1fr_auto]', 'gap-x-3', 'items-center', 'text-right');
      iconWrapper.classList.add('col-start-2');
      titleEl.classList.add('col-start-1', 'row-start-1');
      if (text) textEl.classList.add('col-span-2', 'row-start-2', 'mt-3');

    } else if (align === 'side') {
      // Icono a la izq ocupando 2 filas completas. El título a la derecha y el texto debajo del título
      root.classList.add('grid-cols-[auto_1fr]', 'gap-x-3', 'items-start', 'text-left');
      iconWrapper.classList.add('row-span-2');
      titleEl.classList.add('col-start-2');
      if (text) textEl.classList.add('col-start-2', 'mt-1');
      // Forzamos alineación izquierda aunque esté justificado start
      titleEl.classList.add('text-left');
    }

    // 6. Revelar suavemente la tarjeta
    requestAnimationFrame(() => {
      root.classList.remove("opacity-0");
    });
  });
});
